import { render, staticRenderFns } from "./MasterBatchView.vue?vue&type=template&id=c2c69656&scoped=true"
import script from "./MasterBatchView.vue?vue&type=script&lang=js"
export * from "./MasterBatchView.vue?vue&type=script&lang=js"
import style0 from "./MasterBatchView.vue?vue&type=style&index=0&id=c2c69656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c69656",
  null
  
)

export default component.exports